
















































































import { SfButton, SfIcon, SfImage, SfInput, SfLink } from '~/components';
import { getFormattedMessenger, getFormattedPhone } from "~/modules/boutiques/getters/storeGetters";

import {
  defineComponent,
} from '@nuxtjs/composition-api';


export default defineComponent({
  name: 'BoutiqueItem',
  methods: {
    getFormattedPhone,
    getFormattedMessenger
  },
  components: {
    SfButton,
    SfIcon,
    SfImage,
    SfInput,
    SfLink
  },
  props: {
    boutiqueId: {
      type: Number,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    city: {
      type: String,
      default: ''
    },
    street: {
      type: String,
      default: ''
    },
    countryId: {
      type: String,
      default: ''
    },
    fullAddress: {
      type: String,
      default: ''
    },
    phones: {
      type: Array,
      default: () => []
    },
    whatsapps: {
      type: Array,
      default: () => [],
    },
    image: {
      type: String,
      default: ''
    },
    distance: {
      type: Number,
      default: null
    },
    selected: {
      type: String,
      default: ''
    },
    businessHoursOutput: {
      type: Array,
      default: () => []
    },
    link: {
      type: String,
      default: ''
    },
  },
})
